import PropTypes from 'prop-types';
import React, { useEffect, useState, useRef } from 'react';
import { TimerBannerStyled } from './TimerBannerStyled';
import { LIGHT, DARK} from '@common/Utility/constants';
import { capitalizeFirstLetter } from '@common/Utility/common-utils';
import { useTranslation } from '@common/i18n';

let label = '';

const TimerBanner = props => {
    const t = useTranslation();

    const { timerTheme = LIGHT, offerStartTime, offerEndTime, onVisibilityChange} = props;
    const timerBannerRef = useRef(null);
    const [timeLeft, setTimeLeft] = useState(null);
    
    const [isVisible, setIsVisible] = useState(true);
    const isThemeDark = timerTheme === DARK;

    useEffect(()=>{

        const startTime = new Date(offerStartTime).getTime();
        const endTime = new Date(offerEndTime).getTime();

        const updateTimer = () => {
            const currentTime = new Date().getTime();

            if(currentTime >= startTime){

                // Offer has started

                const remainingTime = endTime - currentTime;
                label = t('EpharmacyFilter.offerEndsIn');

                if(remainingTime > 0){
                    const days = Math.floor(remainingTime/(1000 * 60 * 60 * 24));
                    const hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

                    setTimeLeft({days, hours, minutes, seconds});

                } else {
                    clearInterval(timerBannerRef.current);
                    setIsVisible(false);
                    if (onVisibilityChange) onVisibilityChange(false);
                }

            } else {

                // Calculating Time until the offer starts

                const remainingTime = startTime - currentTime;
                label = t('EpharmacyFilter.offerStartsIn');

                if(remainingTime > 0){
                    const days = Math.floor(remainingTime/(1000 * 60 * 60 * 24));
                    const hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

                    setTimeLeft({days, hours, minutes, seconds});
                }
            }
        };

        timerBannerRef.current = setInterval(updateTimer, 1000);
        return () => {clearInterval(timerBannerRef.current)};

    }, [offerStartTime, offerEndTime, onVisibilityChange]);

    if(!isVisible){
        return null;
    }

    return (
        <>
            {timeLeft && 
                <TimerBannerStyled>
                    <div className={isThemeDark ? 'timerBannerMainsDark' : 'timerBannerMains'}>

                        <div className={isThemeDark ? 'timerBannerSecondsDark' : 'timerBannerSeconds'}>
                            <label className={isThemeDark ? 'timerBannerLabelDark' : 'timerBannerLabel'}>
                                {label}
                            </label>
                        </div>

                        <div className='timeStyles'>
                            {['days', 'hours', 'minutes', 'seconds']?.map((unit, index, array) => (
                                <div key={unit} className='timeStylesSecond'>
                                    <div className='timeStylesThird'>
                                        <div className={isThemeDark ? 'timeStylesLabelDark' : 'timeStylesLabel'}>{`${String(timeLeft[unit]).padStart(2, '0')}`}</div>
                                        <div className={isThemeDark ? 'timeStylesLabelSecondDark' : 'timeStylesLabelSecond'}>{capitalizeFirstLetter(unit)}</div>
                                    </div>
                                    {index < array?.length - 1 && <div className={isThemeDark ? 'timeColonStylesDark' : 'timeColonStyles'}> : </div>}
                                </div>
                            ))}
                        </div>
                    </div>
                </TimerBannerStyled>
            }
        </>
    );
};

TimerBanner.propTypes = {
    timerTheme: PropTypes.string,
    offerStartTime: PropTypes.any,
    offerEndTime: PropTypes.any,
    onVisibilityChange: PropTypes.func,
  };

export default  React.memo(TimerBanner);